const EditorVerbalOptions = {
  menubar: false,
  inline: true,
  skin_url: '/static/tinymce/parlay/ui/Parlay/',
  paste_data_images: false,
  automatic_uploads: false,
  paste_block_drop: true,
  paste_block_img_drop: true,
  content_css: '/static/tinymce/parlay/content/Parlay/content.css',
  plugins: 'lists link image preview visualblocks autolink media searchreplace autoresize wordcount',
  toolbar: 'undo redo | blocks | bold italic forecolor | alignleft aligncenter alignright | bullist numlist',
  block_formats: 'Paragraph=p;',
  content_style: `
    .mce-content-body {
      font-size: 16px !important;
      outline: none !important;
      padding-bottom: 48px;
      line-height: 1.4 !important;
    }
    .mce-content-body ul {
      font-size: 16px !important;
      list-style-type: disc !important;
      margin: 1em 0 1em 1.5em !important;
      padding: 0 !important;
    }
    .mce-content-body ol {
      font-size: 16px !important;
      list-style-type: decimal !important;
      margin: 1em 0 1em 1.5em !important;
      padding: 0 !important;
    }
  `,
  fixed_toolbar_container: '#toolbar-container',
  toolbar_persist: true,
  toolbar_sticky: true,
  branding: false,
  noneditable_class: 'non-editable',
  valid_elements: '*[*]',
  license_key: 'gpl',
  statusbar: false,
  elementpath: false,
};

export { EditorVerbalOptions };



// WEBPACK FOOTER //
// ./src/app/features/Drafts/EditorVerbalOptions.js